import React, { Component } from 'react';
import {
  Modal,
  Button,
  Input,
  Switch,
  Form,
} from 'antd';
import {
  updateProcedureDetails,
} from '../../services/api/cashless-procedures';
import { showError } from '../../actions';

class EditModal extends Component {
  constructor(props) {
    super(props);
    console.log(props, 'props');
    this.state = {
      modalVisible: false,
      loading: true,
      // fetchingVaccine: false,
      procedureId: this.props.editdata.procedureId,
      procedureName: this.props.editdata.procedureName || '',
      procedureType: this.props.editdata.procedureType || '',
      procedureDiscount: this.props.editdata.discount || 0,
      procedureMrp: this.props.editdata.mrp || 0,
      active: this.props.editdata.active,
      shoeErr: false,
      errMessage: '',
    };
  }

  updateDetails = () => {
    const body = {
      procedureId: this.state.procedureId,
      discount: this.state.procedureDiscount,
      mrp: this.state.procedureMrp,
      active: this.state.active,
      networkCenterId: parseInt(this.props.centerId),
    };
    console.log(body, 'body');
    updateProcedureDetails(body)
      .then((res) => {
        console.log(res, 'res');
        if (res.body.message === 'success') {
          this.props.handleClose();
          this.props.reload();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          showErr: true,
          errMessage:
            err.response.data.errorMessage ||
            Object.values(err.response.data.err)[0].msg ||
            'Invalid fields',
        });
      });
  };

  render() {
    const {
      procedureName,
      procedureType,
      procedureDiscount,
      procedureMrp,
      active,
      showErr,
      errMessage,
      loading,
    } = this.state;

    return (
      <Modal
        visible={this.props.modalIsOpen}
        title="Edit Procedure"
        onCancel={() => {
          this.props.handleClose();
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              this.props.handleClose();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!procedureMrp || procedureMrp === 0}
            loading={loading}
            onClick={this.updateDetails}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          autoComplete="off"
        >
          {showErr && <p style={{ color: 'red' }}>{errMessage}</p>}
          <Form.Item label="Procedure Name:">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={procedureName}
              disabled={true}
            />
          </Form.Item>
          <Form.Item label="Procedure Type:">
            <Input
              style={{ width: '50%', marginLeft: '10px' }}
              value={procedureType.split('_')[1]}
              disabled={true}
            />
          </Form.Item>
          <Form.Item label="MRP:">
            <Input
              type="number"
              style={{ width: '50%', marginLeft: '10px' }}
              value={procedureMrp}
              onChange={(e) => {
                this.setState({
                  procedureMrp: parseInt(e.target.value),
                  showErr: false,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="Discount (%):">
            <Input
              type="number"
              min={0}
              max={100}
              step={0.01}
              precision={2}
              style={{ width: '50%', marginLeft: '10px' }}
              value={procedureDiscount}
              onChange={(e) => {
                let newDiscount = parseFloat(
                  parseFloat(e.target.value).toFixed(2)
                );
                newDiscount = newDiscount > 100 ? 100 : newDiscount;
                this.setState({
                  procedureDiscount: newDiscount,
                  showErr: false,
                });
              }}
            />
          </Form.Item>
          <Form.Item label="Status :">
            <Switch
              style={{ marginLeft: '10px' }}
              checked={active}
              onChange={() => {
                this.setState({ active: (active + 1) % 2 });
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default EditModal;
